import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, School } from 'lucide-react';
import { lireJournees } from '../../lib/jpa/gateway.supabase';
import { dateCourte, etatDeLaJournee, jourABruxelles, type JourneeJpa } from '../../lib/jpa/regles';

/*
  L'annonce des journées pédagogiques ouvertes, sur l'accueil du parent.

  C'est le chemin du retour : l'école envoie l'adresse de la page, le parent
  crée son compte, se connecte et atterrit ici. Sans cette carte, il lui
  faudrait retrouver le menu. Elle ne s'affiche que si une journée est
  ouverte : une carte vide à longueur d'année ne serait plus lue.
*/
export default function JourneesPedagogiquesOuvertes() {
  const [ouvertes, setOuvertes] = useState<JourneeJpa[]>([]);

  useEffect(() => {
    let annule = false;
    lireJournees(jourABruxelles(new Date()))
      .then((js) => {
        if (!annule) setOuvertes(js.filter((j) => etatDeLaJournee(j, new Date()) === 'ouverte'));
      })
      /* Une annonce qui échoue se tait : l'accueil reste utilisable. */
      .catch(() => {});
    return () => { annule = true; };
  }, []);

  if (ouvertes.length === 0) return null;

  const parEcole = new Map<string, string[]>();
  for (const j of ouvertes) {
    const ecole = j.ecole ?? j.centre;
    parEcole.set(ecole, [...(parEcole.get(ecole) ?? []), dateCourte(j.date)]);
  }

  return (
    <Link
      to="/journees-pedagogiques"
      className="mt-4 flex min-h-[64px] items-center gap-3 rounded-2xl bg-white p-4 ring-1 ring-primary-200 hover:ring-primary-400"
    >
      <School className="h-6 w-6 flex-shrink-0 text-primary-600" aria-hidden="true" />
      <span className="flex-1">
        <span className="block font-semibold text-gray-900">Journées pédagogiques : inscriptions ouvertes</span>
        {[...parEcole.entries()].map(([ecole, jours]) => (
          <span key={ecole} className="block text-sm text-gray-600">{ecole} — {jours.join(', ')}</span>
        ))}
      </span>
      <ChevronRight className="h-5 w-5 text-gray-400" aria-hidden="true" />
    </Link>
  );
}
